export default __webpack_public_path__ + "static/mesh-4256f750a942f29ac2dd5aab40d4dea4.jpg";